import { render, staticRenderFns } from "./OLogin.vue?vue&type=template&id=a57811e6&scoped=true&"
import script from "./OLogin.vue?vue&type=script&lang=ts&"
export * from "./OLogin.vue?vue&type=script&lang=ts&"
import style0 from "./OLogin.vue?vue&type=style&index=0&id=a57811e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a57811e6",
  null
  
)

export default component.exports